<ng-container *transloco="let _t">

<div class="header-suppl" *ngIf="_currentIdquest!=0" >

  <mat-select [(ngModel)]="_currentIdquest">
		<mat-option [value]="0">{{ _t('app-synthesis-select') }}</mat-option>
		<mat-option *ngFor="let questionnary of questionnaries"
			[value]="questionnary.id">
			{{questionnary.name|replace:'Questionnaire':'Audit'}}
		</mat-option>
	</mat-select>
</div>

<div *ngIf="_currentIdquest==0" class="col-6 offset-3">
<p>&nbsp;</p>
	<h4 class="text-center">{{ _t('app-synthesis-select') }}</h4>
	<mat-option *ngFor="let questionnary of questionnaries"
		(click)="_currentIdquest = questionnary.id">
		{{questionnary.name|replace:'Questionnaire':'Audit'}}
	</mat-option>
<p>&nbsp; <br><br></p>
</div>

<!-- titres si erreurs-->
<div *ngIf="noDiagnosticFound" class="text-center">
	<h3>Aucun {{currentQuestName | replace : 'Questionnaire' : 'audit'
	}} réalisé.</h3>
	<p>{{ _t('app-synthesis-p-0') }}</p>
</div>

<h3 *ngIf="!noDiagnosticFound && gd.selectedBuildingsList.length==0" class="text-end">
	Selectionnez les établissements à analyser 
	<mat-icon>trending_flat</mat-icon>
</h3>


<div *ngIf="filterService.showedData.length>0">

	<app-synthesis-piechart #piechart
		[notes]="notes"
		(changeTriggered)="filterBy('notecat',$event, true)">
	</app-synthesis-piechart>

	<table *ngIf="showResults" 
		class="mat-elevation-z8 table-bordered table-striped container">
		<thead>
		<tr>
			<th>&nbsp; N° &nbsp;</th>
			<th>&nbsp; Etablissement
				<cmat-thbtns class="cmat-thbtns" 
					[filterService]="filterService" 
					[prop]="'etablissement'"
		 			[showFilter]="false">
				</cmat-thbtns>
			</th>
			<th>&nbsp; Auteur
				<cmat-thbtns class="cmat-thbtns"  
					[filterService]="filterService" 
					[prop]="'auteur'">
				</cmat-thbtns>
			</th>

			<th>&nbsp; &nbsp; Note
				<div class="cmat-thbtns">
					<button mat-icon-button (click)="filterService.orderBy('lastNote', false)" [title]="_t('app-synthesis-title-0')"><mat-icon>arrow_drop_down</mat-icon></button>

					<button mat-icon-button (click)="filterService.orderBy('lastNote', true)" [title]="_t('app-synthesis-title-1')"><mat-icon>arrow_drop_up</mat-icon></button>
				</div>
			</th>

			<th>&nbsp; Risques les plus importants</th>
			<th>&nbsp; Liens </th>
		</tr>
		
		</thead>
		<tbody>
		<tr *ngFor="let diagnostic of filterService.showedData; let i=index;">
			<td> {{i+1}} </td>
			<td>
				<p><strong>{{diagnostic.etablissement}}</strong><br/>
				{{diagnostic.adresse}}<br/>
				{{diagnostic.zipcode}} {{diagnostic.town}}
				</p>
				<p *ngIf="diagnostic.directeur!=null"><strong>{{ _t('app-synthesis-strong-1') }}{{diagnostic.directeur}}</strong><br/>
					{{diagnostic.phone}} - {{diagnostic.email}}
				</p>
			</td>
			<td> {{diagnostic.auteur}} 
			</td>
			<td class="text-center">
			  	<div class="note" [ngStyle]="{'background-color': getColor(diagnostic.lastNote), 'color': white}">{{diagnostic.lastNote}}</div>
				<div *ngIf="diagnostic.previousNote!=''" class="text-center"> <br/>Note précédente : <br/>{{diagnostic.previousNote}} </div>
			</td>
			<td><ul>
				<li *ngFor="let risk of diagnostic.importantRisks">
					{{risk}}
				</li>
			</ul></td>
			<td> 
				<a *ngIf="diagnostic.pdfUrl!=''"
					[href]="diagnostic.pdfUrl"
					target="_blank" 
					[title]="_t('app-synthesis-title-2')"
					mat-raised-button color="primary">
				<mat-icon>picture_as_pdf</mat-icon>
				</a><br/>
				<a [routerLink]="['/rm','generator', diagnostic.id_diagnostic]"
					[title]="_t('app-synthesis-title-3')"
					mat-raised-button color="secondary">
				<mat-icon>account_tree</mat-icon>
				</a><br/>
			</td>
		</tr>
		</tbody>
	</table>

	<p><br><br><br><br></p>
</div>



<!-- MODE D'EMPLOI -->
<div *ngIf="showManual" class="col-10 instructions">
	<h2>{{ _t('app-synthesis-h2-0') }}</h2>
	<p>{{ _t('app-synthesis-p-1') }}</p>
	<p>{{ _t('app-synthesis-p-2') }}</p>
	<p>{{ _t('app-synthesis-p-2bis') }}</p>
	<p>{{ _t('app-synthesis-p-2ter') }}</p>
	<p>{{ _t('app-synthesis-p-3') }}</p>
	<p>{{ _t('app-synthesis-p-4') }}</p>
	<p>{{ _t('app-synthesis-p-5') }}</p>

	<p class="text-end"><button mat-raised-button (click)="showManual=false"><mat-icon>check</mat-icon>OK</button></p>
</div>

</ng-container>